"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REPLACEMENTS_PREVIOUS_BTN = exports.REPLACEMENTS_NEXT_BTN = void 0;
const REPLACEMENTS_PREVIOUS_BTN = exports.REPLACEMENTS_PREVIOUS_BTN = 'replacements-previous-btn';
const REPLACEMENTS_NEXT_BTN = exports.REPLACEMENTS_NEXT_BTN = 'replacements-next-btn';